












import { computed, defineComponent } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionBookAppointment",
  components: {
    TransactionView,
  },
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
  setup(props) {
    const { authUser } = useAuthUser();
    const isProvider = computed(
      () => (props.transaction.details.appointment as Appointment).providerId === authUser.value?.id
    );
    const isConsumer = computed(
      () => (props.transaction.details.appointment as Appointment).consumerId === authUser.value?.id
    );
    const providerScreenName = computed(() =>
      resolveUserName((props.transaction.details.appointment as Appointment).provider)
    );
    const consumerScreenName = computed(() =>
      resolveUserName((props.transaction.details.appointment as Appointment).consumer)
    );

    const transactionText = computed(() => {
      return props.transaction.type === "REFUND" ? $t("Refund for cancelled date with") : $t("Date with");
    });
    return { isProvider, isConsumer, providerScreenName, consumerScreenName, transactionText };
  },
});
